import React, { useState } from "react";
import { Box, List, ListItemButton, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import { useNavigate, useLocation } from "react-router-dom";

function ProjectsSidebar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [selectedItem, setSelectedItem] = useState("projects");

  const menuItems = [
    {
      id: "home",
      label: "Home",
      icon: <HomeOutlinedIcon />,
      path: "/projects"
    },
    {
      id: "projects",
      label: "Projects",
      icon: <FolderOutlinedIcon />,
      path: "/projects"
    },
    {
      id: "people",
      label: "People",
      icon: <PeopleOutlinedIcon />,
      path: "/team-members"
    },
  ];

  const handleItemClick = (item) => {
    setSelectedItem(item.id);
    if (item.path) {
      navigate(item.path);
    }
  };

  return (
    <Box
      sx={{
        width: 50,
        borderRight: "1px solid #eee",
        height: "100vh",
        position: "fixed",
        left: 0,
        top: 64, // Below the header
        bgcolor: "#fafafa",
        zIndex: 1100,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingTop: 2,
      }}
    >
      <List sx={{ width: "100%", padding: 0 }}>
        {menuItems.map((item) => {
          const isSelected = pathname === item.path;
          return (
            <Tooltip key={item.id} title={item.label} placement="right" arrow>
              <ListItemButton
                selected={isSelected}
                onClick={() => handleItemClick(item)}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  py: 2,
                  px: 0,
                  minHeight: 64,
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "#e3f2fd",
                    borderLeft: "3px solid #1976d2",
                    "&:hover": {
                      backgroundColor: "#e3f2fd",
                    },
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: "auto",
                    color: isSelected ? "#1976d2" : "inherit",
                    justifyContent: "center",
                    mb: 0.5,
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{
                    fontSize: "11px",
                    fontWeight: isSelected ? 600 : 400,
                    color: isSelected ? "#1976d2" : "inherit",
                    textAlign: "center",
                  }}
                  sx={{ margin: 0 }}
                />
              </ListItemButton>
            </Tooltip>
          );
        })}
      </List>
    </Box>
  );
}

export default ProjectsSidebar;
